import { render } from "./cooperate.vue?vue&type=template&id=79526bcb&scoped=true"
import script from "./cooperate.vue?vue&type=script&lang=js"
export * from "./cooperate.vue?vue&type=script&lang=js"

import "./cooperate.vue?vue&type=style&index=0&id=79526bcb&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79526bcb"]])

export default __exports__